// extracted by mini-css-extract-plugin
export default {"ModalContainer":"style_ModalContainer__+CryP"};